module.exports = (__parcel__import__("6gTDR")).then(() => parcelRequire('ahP7X'));